import 'babel-polyfill'
// Vue
import Vue from 'vue'
import App from './App'
// 核心插件
import d2Admin from '@/plugin/d2admin'
// store
import store from '@/store/index'
// 多国语
import i18n from './i18n'
// 全局过滤
import '@/libs/filters';

import './assets/css/icon.css';

// neditor
import VueNeditorWrap from 'vue-neditor-wrap'
// 菜单和路由设置
import router from './router'
import menuHeader from '@/menu/header'
import menuAside from '@/menu/aside'
import { frameInRoutes } from '@/router/routes'

//引入导出excel
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
// import { GetMenus } from '@/api/allactions'
//联级菜单插件
import EleMultiCascader from "ele-multi-cascader"
Vue.use(EleMultiCascader);

// import elCascaderMulti from "el-cascader-multi";
// Vue.use(elCascaderMulti);

import './assets/iconfont/iconfont.css'
//工作台图表
import VeLine from 'v-charts/lib/line.common.js'
Vue.component(VeLine.name, VeLine)

import VeHistogram from 'v-charts/lib/histogram.common.js'
Vue.component(VeHistogram.name, VeHistogram)

import VeRing from 'v-charts/lib/ring.common.js'
Vue.component(VeRing.name, VeRing)

import VeHeatmap from 'v-charts/lib/heatmap.common.js'
Vue.component(VeHeatmap.name, VeHeatmap)

import VeFunnel from 'v-charts/lib/funnel.common.js'
Vue.component(VeFunnel.name, VeFunnel)

import VeWordcloud from 'v-charts/lib/wordcloud.common.js'
Vue.component(VeWordcloud.name, VeWordcloud)

//打印
import Print from 'vue-print-nb'
Vue.use(Print);

//引入复制剪切板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

//表格导出
import pluginExport from '@d2-projects/vue-table-export'
Vue.use(pluginExport)



// 核心插件
Vue.use(d2Admin)

// 引入echarts
import echarts from 'echarts'
require('echarts-gl')
Vue.prototype.$echarts = echarts

//无缝滚动插件
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

window.downLoadData = ''

new Vue({
  router,
  store,
  i18n,
  data: function () {
    return {
      menuAsidesAll: [],
      searchMenu: []
    }
  },
  render: h => h(App),
  created() {
    // 处理路由 得到每一级的路由设置
    this.$store.commit('d2admin/page/init', frameInRoutes)
    // 设置顶栏菜单
    this.$store.commit('d2admin/menu/headerSet', menuHeader)
    // 设置侧边栏菜单
    this.$store.commit('d2admin/menu/asideSet', menuAside)

    // GetMenus().then((res) =>{
    //   // console.log(res)
    //   // this.$store.commit('d2admin/page/init', this.menuAsidesAll)
    //   this.renrenMenuToD2AdminMenu(res.data[0].children)
    //   this.$store.commit('d2admin/menu/asideSet', this.menuAsidesAll)
    // })

  },
  mounted() {
    // GetMenus().then((res) =>{
    //   // console.log(res)
    //   // this.$store.commit('d2admin/page/init', this.menuAsidesAll)
    //   this.renrenMenuToD2AdminMenu(res.data[0].children)
    //   this.$store.commit('d2admin/menu/asideSet', this.menuAsidesAll)
    // })


    // 展示系统信息
    this.$store.commit('d2admin/releases/versionShow')
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch('d2admin/account/load')
    // 获取并记录用户 UA
    this.$store.commit('d2admin/ua/get')
    // 初始化全屏监听
    this.$store.dispatch('d2admin/fullscreen/listen')

    // // 初始化菜单搜索功能
    // this.$store.commit('d2admin/search/init', this.menuAsidesAll)
  },
  methods: {
    renrenMenuToD2AdminMenu(menuArray, routeNameDict) {
      // console.log(menuArray,routeNameDict,"1111");

      const transform = menu => ({
        ...menu.children.length > 0 ? { children: menu.children.map(e => transform(e)) } : {},
        id: menu.id,
        icon: menu.icon,
        title: menu.name,
        name: menu.name,
        path: menu.url
      })
      // console.log(menuArray.map(e => transform(e)))
      this.menuAsidesAll = menuArray.map(e => transform(e))
      return menuArray.map(e => transform(e))
    },

  }
}).$mount('#app')
